import Vue from 'vue'
import { JtechMessage } from 'src/plugins/system.messages'
Vue.use(JtechMessage)

export const messageBox = {
  success: function (content, detail = '') {
    JtechMessage.success(content, detail)
  },
  warn: function (content, detail = '') {
    JtechMessage.warn(content, detail)
  },
  info: function (content, detail = '') {
    JtechMessage.info(content, detail)
  },
  error: function (content, detail = '') {
    JtechMessage.error(content, detail)
  }
}
